import { Outlet } from 'react-router-dom';
import MainLayout from '../components/layouts/MainLayout';

const LayoutRoute = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default LayoutRoute;
